function testimonial_typeslick() {
    $(".block__testimonial--reviewtype-content").hasClass("slick-initialized") ||
        $(".block__testimonial--reviewtype-content")
            .slick({
                infinite: !1,
                slidesToShow: 5,
                slidesToScroll: 1,
                dots: !1,
                prevArrow: $(".block__testimonial-headingarrow.slick-prev"),
                nextArrow: $(".block__testimonial-headingarrow.slick-next"),
                responsive: [
                    { breakpoint: 576, settings: { slidesToShow: 4, slidesToScroll: 1 } },
                    { breakpoint: 481, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                    { breakpoint: 360, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                ],
            })
            .on("afterChange", function () {
                $(".slick-slide").removeClass("is-active"), $(".slick-current").addClass("is-active"), $(".slick-current .block__testimonial--reviewimg").trigger("click");
            })
            .on("setPosition", function (t, i) {
                i.$slides.css("height", i.$slideTrack.height() + "px");
            });
}
function collection_productlist() {
    $(".block__productlist--itemlist").hasClass("slick-initialized") ||
        $(".block__productlist--itemlist")
            .slick({
                infinite: !1,
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: !1,
                prevArrow: `<button class="block__productlist-arrow slick-prev slick-arrow prev-arrow">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.8284 10.9999L13.1924 5.63589L11.7782 4.22168L4 11.9999L11.7782 19.778L13.1924 18.3638L7.8284 12.9999H20V10.9999H7.8284Z" fill="#22202E"/>
      </svg></button>`,
                nextArrow: `<button class="block__productlist-arrow slick-next slick-arrow next-arrow">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" fill="#22202E"/>
      </svg></button>`,
                unslick: !1,
                responsive: [
                    { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 1, unslick: !1 } },
                    { breakpoint: 768, settings: "unslick" },
                ],
            })
            .on("setPosition", function (t, i) {
                i.$slides.css("height", i.$slideTrack.height() + "px");
            });
}
function product_multitab() {
    $(".block__product--innertab-content").hasClass("slick-initialized") &&
        setTimeout(function () {
            $(".block__product--innertab-content").slick("unslick");
        }, 10),
        setTimeout(function () {
            $(".block__product--innertab-content").slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                asNavFor: ".block__product--innertab-desc-content",
                arrows: !0,
                prevArrow: `<button class="block__slick-arrow slick-prev slick-arrow prev-arrow">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z" fill="#43974F"/></svg></button>`,
                nextArrow: `<button class="block__slick-arrow slick-next slick-arrow next-arrow">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" fill="#43974F"/></svg></button>`,
                infinite: !1,
                focusOnSelect: !0,
                responsive: [
                    { breakpoint: 600, settings: { slidesToShow: 4, slidesToScroll: 1 } },
                    { breakpoint: 480, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                ],
            });
        }, 10);
}
function product_multitab_mob() {
    $(".block__product--innertab-content").hasClass("slick-initialized") &&
        setTimeout(function () {
            $(".block__product--innertab-content").slick("unslick");
        }, 10),
        setTimeout(function () {
            $(".block__product--innertab-content")
                .slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    asNavFor: ".block__product--innertab-desc-content",
                    rows: 1,
                    arrows: !0,
                    prevArrow: `<button class="block__slick-arrow slick-prev slick-arrow prev-arrow">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z" fill="#43974F"/></svg></button>`,
                    nextArrow: `<button class="block__slick-arrow slick-next slick-arrow next-arrow">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" fill="#43974F"/></svg></button>`,
                    infinite: !1,
                })
                .on("setPosition", function (t, i) {
                    i.$slides.css("height", i.$slideTrack.height() + "px");
                });
        }, 10);
}
var daily_routin_opt = {
    infinite: !1,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: !0,
    prevArrow: `<button class="block__shopbundle-arrow slick-prev slick-arrow prev-arrow">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.8284 10.9999L13.1924 5.63589L11.7782 4.22168L4 11.9999L11.7782 19.778L13.1924 18.3638L7.8284 12.9999H20V10.9999H7.8284Z" fill="#22202E"/></svg></button>`,
    nextArrow: `<button class="block__shopbundle-arrow slick-next slick-arrow next-arrow">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" fill="#22202E"/></svg></button>`,
    responsive: [
        { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2, centerMode: !0, centerPadding: "20px", speed: 300, infinite: !0, slidesToScroll: 1 } },
        { breakpoint: 481, settings: { slidesToShow: 1, centerMode: !0, centerPadding: "80px", infinite: !0, dots: !1, slidesToScroll: 1 } },
        { breakpoint: 370, settings: { slidesToShow: 1, centerMode: !0, centerPadding: "30px", infinite: !0, slidesToScroll: 1, dots: !1 } },
    ],
};
function Dailyroutine_filter_result() {
    if ($(".block__dailyroutine--tabfilteractive .block__dailyroutine--filter-item input:checked").length > 0) {
        $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").hasClass("slick-initialized") && $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").slick("unslick"),
            $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistwrap").css("display", "none"),
            $(".block__dailyroutine--itemactive .block__dailyroutine--item").removeClass("active-item"),
            $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").hasClass("filter-loading")
                ? $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").empty().html('<span class="block__dailyroutine--itemlistfilter-loadicon"></span>').css("display", "grid")
                : $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").empty().html('<span class="block__dailyroutine--itemlistfilter-loadicon"></span>').css("display", "grid").addClass("filter-loading"),
            $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").css("display", "grid");
        var t,
            i = "";
        (e = []),
            $(".block__dailyroutine--tabfilteractive .block__dailyroutine--filter-item input:checked").each(function () {
                var t = $(this).attr("data-inputval").trim();
                -1 != t.indexOf("+") && (t = t.replace("+", "%2B"));
                var o = t.replace(/ /g, "+");
                (i = "" != i ? i + "&filter.p.tag=" + o : "&filter.p.tag=" + o), e.push($(this).val());
            }),
            (t = $(".block__dailyroutine--itemactive").attr("data-collectionheadingurl") + "?view=homepage_filter" + i),
            $.ajax({
                url: t,
                method: "GET",
                dataType: "html",
                success: function (o) {
                    var l = $(o).find(".block__collectiontemplate--productitem");
                    if (l.length > 0)
                        $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").hasClass("slick-initialized") && $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").slick("unslick"),
                            $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").removeClass("filter-loading"),
                            $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").empty(),
                            setTimeout(function () {
                                l.length > 0
                                    ? $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").html(l)
                                    : $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").html("No products found").css("display", "block"),
                                    l.length > 2 &&
                                        ($(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").slick(daily_routin_opt),
                                        $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").slick("setPosition"),
                                        $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").on("init", function (t) {}),
                                        $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").slick("refresh")),
                                    $(".card-product-subscription-radio-input").change(function () {
                                        if (($(this).parents(".block__card-product-subscriptionwrap").find(".card-product-subscription-radio").removeClass("inputchecked-disable"), $(this).is(":checked"))) {
                                            if (($(this).parents(".card-product-subscription-radio").addClass("inputchecked-disable"), "subscription" == $(this).val())) {
                                                $(this).parents(".block_card_product__item---plan-list-dropbox").addClass("product-subscription-grp-active"),
                                                    $(this).parents(".quick-add").find(".card_product--pricewrap").addClass("card_product_subscriptionprice");
                                                var t = $(this).parents(".card-product-subscription-radio").find(".block_card_product_item-subscriptionlist").val();
                                                $(this).parents(".quick-add").find('input[name="selling_plan"]').attr("value", t);
                                            } else
                                                $(this).parents(".block_card_product__item---plan-list-dropbox").removeClass("product-subscription-grp-active"),
                                                    $(this).parents(".quick-add").find(".card_product--pricewrap").removeClass("card_product_subscriptionprice"),
                                                    $(this).parents(".quick-add").find('input[name="selling_plan"]').attr("value", "");
                                        }
                                    });
                            }, 500);
                    else if (i.indexOf("Health+Focus_")) {
                        var a = t.replace(/Focus_/g, "Focus_+");
                        $.ajax({
                            url: a,
                            method: "GET",
                            dataType: "html",
                            success: function (t) {
                                var i = $(t).find(".block__collectiontemplate--productitem");
                                i.length > 0
                                    ? ($(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").hasClass("slick-initialized") &&
                                          $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").slick("unslick"),
                                      $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").removeClass("filter-loading"),
                                      $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").empty())
                                    : ($(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").removeClass("filter-loading"), $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").empty()),
                                    setTimeout(function () {
                                        i.length > 0
                                            ? $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").html(i)
                                            : $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").html("No products found").css("display", "block"),
                                            i.length > 2 &&
                                                ($(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").slick(daily_routin_opt),
                                                $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").slick("setPosition"),
                                                $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").on("init", function (t) {}),
                                                $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").slick("refresh")),
                                            $(".card-product-subscription-radio-input").change(function () {
                                                if (($(this).parents(".block__card-product-subscriptionwrap").find(".card-product-subscription-radio").removeClass("inputchecked-disable"), $(this).is(":checked"))) {
                                                    if (($(this).parents(".card-product-subscription-radio").addClass("inputchecked-disable"), "subscription" == $(this).val())) {
                                                        $(this).parents(".block_card_product__item---plan-list-dropbox").addClass("product-subscription-grp-active"),
                                                            $(this).parents(".quick-add").find(".card_product--pricewrap").addClass("card_product_subscriptionprice");
                                                        var t = $(this).parents(".card-product-subscription-radio").find(".block_card_product_item-subscriptionlist").val();
                                                        $(this).parents(".quick-add").find('input[name="selling_plan"]').attr("value", t);
                                                    } else
                                                        $(this).parents(".block_card_product__item---plan-list-dropbox").removeClass("product-subscription-grp-active"),
                                                            $(this).parents(".quick-add").find(".card_product--pricewrap").removeClass("card_product_subscriptionprice"),
                                                            $(this).parents(".quick-add").find('input[name="selling_plan"]').attr("value", "");
                                                }
                                            });
                                    }, 500);
                            },
                            error: function (t) {
                                console.error("Error fetching products: ", t);
                            },
                        });
                    } else
                        $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").removeClass("filter-loading"),
                            $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").empty().html("No products found").css("display", "block");
                },
                error: function (t) {
                    console.error("Error fetching products: ", t);
                },
            });
    } else
        $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistfilterwrap").empty().html('<span class="block__dailyroutine--itemlistfilter-loadicon"></span>').css("display", "none").addClass("filter-loading"),
            $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistwrap").css("display", "block"),
            $(".block__dailyroutine--itemactive .block__dailyroutine--itemlistwrap").slick("refresh");
    setTimeout(function () {
        $(".block__dailyroutine--itemlistfilterwrap .card-product-subscription-radio-input").change(function (t) {
            t.preventDefault(),
                $(this).parents(".block__card-product-subscriptionwrap").find(".card-product-subscription-radio").removeClass("inputchecked-disable"),
                $(this).is(":checked") &&
                    ($(this).parents(".card-product-subscription-radio").addClass("inputchecked-disable"),
                    "subscription" == $(this).val()
                        ? ($(this).parents(".block_card_product__item---plan-list-dropbox").addClass("product-subscription-grp-active"), $(".card_product--pricewrap").addClass("card_product_subscriptionprice"))
                        : ($(this).parents(".block_card_product__item---plan-list-dropbox").removeClass("product-subscription-grp-active"), $(".card_product--pricewrap").removeClass("card_product_subscriptionprice")));
        }),
            $(".block__dailyroutine--alltabs-inner").removeClass("block__dailyroutine--tabwrap-active"),
            $("body").removeClass("dailyroutine__tabactive"),
            $(".block__dailyroutine--tabwrap").removeClass("inner-activecontent");
    }, 1200);
}
$(document).ready(function () {
    function t() {
        $(".block__testimonial--reviewcontent").hasClass("slick-initialized") ||
            $(".block__testimonial--reviewcontent")
                .slick({
                    infinite: !1,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: !1,
                    prevArrow: `<button class="block__testimonial-arrow slick-prev slick-arrow prev-arrow">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z" fill="#43974F"/></svg></button>`,
                    nextArrow: `<button class="block__testimonial-arrow slick-next slick-arrow next-arrow">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" fill="#43974F"/></svg></button>`,
                    responsive: [
                        { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                        { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                        { breakpoint: 768, settings: { infinite: !0, slidesToShow: 2, slidesToScroll: 1, centerMode: !0, centerPadding: "20px", speed: 300 } },
                        { breakpoint: 576, settings: { infinite: !0, slidesToShow: 1, slidesToScroll: 1, centerMode: !0, centerPadding: "40px", speed: 300 } },
                        { breakpoint: 360, settings: { infinite: !0, slidesToShow: 1, slidesToScroll: 1, centerMode: !0, centerPadding: "20px", speed: 300 } },
                    ],
                })
                .on("setPosition", function (t, i) {
                    i.$slides.css("height", i.$slideTrack.height() + "px");
                });
    }
    $(".block__header--megamenu-list").mouseenter(function () {
        $("body").addClass("header-menu-open");
    }),
        $(".block__header--megamenu-list").mouseleave(function () {
            $("body").removeClass("header-menu-open");
        }),
        $(".block__header--quizbtn").click(function () {
            $(".main-quiz-popup-sections").addClass("openquiz-model"), $("body").addClass("quizmodel-close"), localStorage.removeItem("quiz_producttag"), localStorage.removeItem("quiz_producturl");
        }),
        $(".menu-drawer__closeicon").click(function () {
            $(".header__icon--menu").trigger("click");
        }),
        $(".block__herobanner--mobilewrapper").slick({ infinite: !1, slidesToShow: 1, slidesToScroll: 1, dots: !0, arrows: !1 }),
        t(),
        767 >= $(window).width()
            ? testimonial_typeslick()
            : $(".block__testimonial--reviewtype-content").hasClass("slick-initialized") &&
              setTimeout(function () {
                  $(".block__testimonial--reviewtype-content").slick("unslick");
              }, 100),
        $(".block__testimonial--reviewimg").click(function () {
            var i = $(this).parents(".block__testimonial--reviewtype").attr("data-reviewtype");
            $(".block__testimonial--reviewtype").removeClass("is-active"),
                $(this).parents(".block__testimonial--reviewtype").addClass("is-active"),
                $(".block__testimonial--reviewcontent").hasClass("slick-initialized") && $(".block__testimonial--reviewcontent").slick("unslick"),
                $(".block__testimonial--reviewcontent").empty(),
                $(".block__testimonial--blockcontent .block__testimonial--subreviewcontent").each(function () {
                    var t = $(this).attr("data-reviewcontent");
                    i == t && $(this).clone().appendTo(".block__testimonial--reviewcontent");
                }),
                $(".block__testimonial--subreviewcontent").removeClass("is-content-active"),
                $('.block__testimonial--subreviewcontent[data-reviewcontent="' + i + '"]').addClass("is-content-active"),
                setTimeout(function () {
                    t();
                }, 100);
        }),
        $(".block__shopbundle--itemlist").slick(daily_routin_opt),
        $(".block__shopbundle--itemlist").slick("setPosition"),
        $(".block__shopbundle--itemlist").on("init", function (t) {}),
        767 >= $(window).width()
            ? $(".block__productlist--itemlist").hasClass("slick-initialized") &&
              setTimeout(function () {
                  $(".block__productlist--itemlist").slick("unslick");
              }, 100)
            : collection_productlist(),
        $(".block__dailyroutine--itemlistwrap").slick(daily_routin_opt),
        $(".block__dailyroutine--itemlistwrap").slick("setPosition"),
        $(".block__dailyroutine--itemlistwrap").on("init", function (t) {}),
        $(".block__dailyroutine--tab").click(function () {
            var t = $(this).parents(".block__dailyroutine--tabinner").attr("data-collectionheading");
            $(".block__dailyroutine--tabwrap").addClass("inner-activecontent"),
                $(".block__dailyroutine--tabinner").removeClass("block__dailyroutine--tabactive"),
                $(this).parents(".block__dailyroutine--tabinner").addClass("block__dailyroutine--tabactive"),
                $(".block__dailyroutine--tabfilter-content").removeClass("block__dailyroutine--tabfilteractive"),
                $('.block__dailyroutine--tabfilter-content[data-collectionfilter="' + t + '"]').addClass("block__dailyroutine--tabfilteractive"),
                $(".block__dailyroutine--itemlist").removeClass("block__dailyroutine--itemactive"),
                $('.block__dailyroutine--itemlist[data-collectionheading="' + t + '"]').addClass("block__dailyroutine--itemactive"),
                $(".block__dailyroutine--itemlistwrap").slick("refresh");
        }),
        $(window).width() > 767
            ? $('.block__dailyroutine--filter-item input[type="checkbox"]').change(function (t) {
                  t.preventDefault(), console.log("in"), Dailyroutine_filter_result();
              })
            : $(".block__dailyroutine-mobilebtn").click(function (t) {
                  t.preventDefault(), Dailyroutine_filter_result();
              }),
        $(".block__dailyroutine--tabfilter-mobilewrap").click(function () {
            $(".block__dailyroutine--alltabs-inner").addClass("block__dailyroutine--tabwrap-active"), $("body").addClass("dailyroutine__tabactive");
        }),
        $(".block__dailyroutine--tab_mobile_activetab").click(function () {
            $(".block__dailyroutine--tabwrap").removeClass("inner-activecontent");
        });
    var i,
        o,
        l = $(".block__dailyroutine--tabwrap"),
        a = $(".block__dailyroutine--tabfilter-mobilewrap");
    function n(t) {
        var i = $(t).attr("data-producttab");
        $(".block__product--innertab").removeClass("block__product--innertab-active");
        var o = $('.block__product--tabcontent--desc[data-producttabcontent="' + i + '"]').attr("data-slick-index");
        $(".block__product--innertab-desc-content").slick("slickGoTo", o), $(t).addClass("block__product--innertab-active");
    }
    function c() {
        $(".block__multitab-collectionbundle-tabactive .block__multitab-collectionbundle--item").each(function (t) {
            t >= 8 && $(this).fadeOut(200).addClass("hide");
        }),
            $(".block__multitab-collectionbundle-tabactive .block__multitab-collectionbundle-btntxt").on("click", function (t) {
                t.preventDefault(),
                    $(this),
                    $(".block__multitab-collectionbundle-tabactive .block__multitab-collectionbundle--item:hidden").slice(0, 8).slideDown(),
                    0 == $(".block__multitab-collectionbundle-tabactive .block__multitab-collectionbundle--item:hidden").length && ($(this).fadeOut(200), $(this).removeClass("active"));
            }),
            setTimeout(function () {
                console.log($(".block__multitab-collectionbundle-tabactive .block__multitab-collectionbundle--item:hidden").length),
                    0 == $(".block__multitab-collectionbundle-tabactive .block__multitab-collectionbundle--item:hidden").length
                        ? ($(".block__multitab-collectionbundle-tabactive .block__multitab-collectionbundle-btnwrap").fadeOut(200), $(this).removeClass("active"))
                        : ($(".block__multitab-collectionbundle-tabactive .block__multitab-collectionbundle-btnwrap").fadeIn(200), $(this).addClass("active"));
            }, 300);
    }
    $(document).on("click", function t(i) {
        l.is(i.target) ||
            0 !== l.has(i.target).length ||
            a.is(i.target) ||
            0 !== a.has(i.target).length ||
            ($(".block__dailyroutine--alltabs-inner").removeClass("block__dailyroutine--tabwrap-active"), $("body").removeClass("dailyroutine__tabactive"), $(".block__dailyroutine--tabwrap").removeClass("inner-activecontent"));
    }),
        767 >= $(window).width() &&
            $(".footer-block--menu .footer-block__heading").click(function () {
                $(".footer-block--menu .footer-block__details-content:visible").not($(this).next(".footer-block__details-content")).slideUp(),
                    $(".footer-block__heading").not($(this)).removeClass("is-active"),
                    $(this).next(".footer-block__details-content").slideToggle(),
                    $(this).toggleClass("is-active");
            }),
        $(".cart-drawer--collectionproduct").slick({
            infinite: !1,
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: !1,
            arrows: !1,
            responsive: [
                { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                { breakpoint: 390, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            ],
        }),
        $(".block__product-multitab-txt").click(function () {
            var t = $(this).attr("data-producttab");
            $(".block__product-multitab-txt").removeClass("is-active"),
                $(this).addClass("is-active"),
                $(".block__product-multitabcontent .block__product-multitabcontent-wrap").removeClass("is-active"),
                $('.block__product-multitabcontent .block__product-multitabcontent-wrap[data-producttabcontent="' + t + '"]').addClass("is-active"),
                $(window).width() >= 576 ? product_multitab() : 575 >= $(window).width() && product_multitab_mob(),
                $(".block__product--innertab-desc-content").slick("refresh"),
                setTimeout(function () {
                    $(".block__product--innertab").click(function () {
                        n($(this));
                    });
                }, 300);
        }),
        $(".block__product--innertab").click(function () {
            n($(this));
        }),
        $(".block__product--innertab-desc-content").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: !0,
            infinite: !1,
            adaptiveHeight: !0,
            asNavFor: ".block__product--innertab-content",
            prevArrow: `<button class="block__slick-arrow slick-prev slick-arrow prev-arrow">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z" fill="#43974F"/></svg></button>`,
            nextArrow: `<button class="block__slick-arrow slick-next slick-arrow next-arrow">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" fill="#43974F"/></svg></button>`,
        }),
        576 > $(window).width()
            ? ($(".block__product--innertab").length > 3 ? product_multitab_mob() : product_multitab(),
              $(".block__product--innertab-desc-content")
                  .on("afterChange", function (t, i, o, l) {
                      if (void 0 != o) {
                          $(".block__product--innertab").removeClass("block__product--innertab-active");
                          var a = $('.block__product--tabcontent--desc[data-slick-index="' + o + '"]').attr("data-producttabcontent");
                          $('.block__product--innertab[data-producttab="' + a + '"]').addClass("block__product--innertab-active");
                      }
                  })
                  .trigger("afterChange"))
            : (product_multitab(),
              $(".block__product--innertab-desc-content")
                  .on("afterChange", function (t, i, o, l) {
                      void 0 != o && ($(".block__product--innertab").removeClass("block__product--innertab-active"), $('.block__product--innertab[data-slick-index="' + o + '"]').addClass("block__product--innertab-active"));
                  })
                  .trigger("afterChange")),
        $("#newsletter-popup").length > 0 &&
            (function () {
                var t = new Date();
                if (null == localStorage.getItem("tmx-newsletter") || "undefined" == localStorage.getItem("tmx-newsletter")) $("#newsletter-popup").addClass("active-newsletter"), $("body").addClass("is-newsletter-open");
                else {
                    var i = new Date(t) - new Date(localStorage.getItem("tmx-newsletter")),
                        o = i % 1e3;
                    Math.floor((i = (i - o) / 1e3) / 86400) > 2 && (localStorage.removeItem("tmx-newsletter"), $("#newsletter-popup").addClass("active-newsletter"), $("body").addClass("is-newsletter-open"));
                }
            })(),
        $(".block__nl-popup-close .block__nl-popup-icon").click(function () {
            $("#newsletter-popup").removeClass("active-newsletter"), $("body").removeClass("is-newsletter-open");
            var t = new Date();
            localStorage.setItem("tmx-newsletter", t);
        }),
        $(".block__nl-wraper-popup .block__nl-popup-txtcontent").click(function () {
            $(".block__nl-popup-close .block__nl-popup-icon").trigger("click");
        }),
        $(".block__faq__question").click(function () {
            $(".block__faq__question").not($(this)).removeClass("faq-is-active"),
                $(this).hasClass("faq-is-active") ? $(this).removeClass("faq-is-active") : $(this).addClass("faq-is-active"),
                $(".block__faq__answer").not($(this).siblings(".block__faq__answer")).slideUp(500),
                $(this).next().slideToggle(500);
        }),
        $(".block__faq-tabtype").click(function () {
            var t = $(this).attr("data-faqtabtype");
            $(".block__faq-tabtype").removeClass("block__faqtab-active"),
                $(this).addClass("block__faqtab-active"),
                $("html, body").animate({ scrollTop: $('.block__faq-queans-wrapper[data-faqtabcontent="' + t + '"]').offset().top - 50 }, 1e3);
        }),
        setTimeout(function () {
            let t = document.querySelector('.block__faq__answer a[title="#quiz"]');
            t &&
                t.addEventListener("click", function (t) {
                    t.preventDefault(), document.querySelector(".block__header--quizbtn").click();
                });
        }, 500),
        $(".block__abotuus-meet-videoarrow").click(function () {
            document.getElementById("block__aboutus-meetvideo").paused
                ? ($("#block__aboutus-meetvideo").trigger("play"), $(this).addClass("block__videoarrow-play"), $(".block__aboutus-meet-videoimg").css("display", "none"))
                : ($("#block__aboutus-meetvideo").trigger("pause"), $(this).removeClass("block__videoarrow-play"), $(".block__aboutus-meet-videoimg").css("display", "block"));
        }),
        $(".block__faqhelp__question").click(function () {
            $(".block__faqhelp__question").not($(this)).removeClass("faq-is-active"),
                $(this).hasClass("faq-is-active") ? $(this).removeClass("faq-is-active") : $(this).addClass("faq-is-active"),
                $(".block__faqhelp__answer").not($(this).siblings(".block__faqhelp__answer")).slideUp(500),
                $(this).next().slideToggle(500);
        }),
        $(".block__ourpartner-linkcontent").slice(0, 44).show(),
        $("#block__ourpartner-loadmore").on("click", function (t) {
            t.preventDefault(), $(".block__ourpartner-linkcontent:hidden").slice(0, 4).slideDown(), 0 == $(".block__ourpartner-linkcontent:hidden").length && $("#block__ourpartner-loadmore").fadeOut(500);
        }),
        $(".block__multitab-collectionbundle-selectmob input"),
        $(".block__multitab-collectionbundle-selectmob").click(function () {
            $(this).parents(".block__multitab-collectionbundle-select").toggleClass("active");
        }),
        $(".block__multitab-collectionbundle-tabheading").click(function () {
            var t = $(this).attr("data-collectionheading");
            $(".block__multitab-collectionbundle-selectmob input").val(t),
                $(".block__multitab-collectionbundle-select").removeClass("active"),
                $(".block__multitab-collectionbundle-tab").removeClass("block__multitab-collectionbundle-tabactive"),
                $(this).parents(".block__multitab-collectionbundle-tab").addClass("block__multitab-collectionbundle-tabactive"),
                $(".block__multitab-collectionbundle-tabcontent").removeClass("block__multitab-collectionbundle-tabactive"),
                $('.block__multitab-collectionbundle-tabcontent[data-collectionproduct="' + t + '"]').addClass("block__multitab-collectionbundle-tabactive"),
                c();
        }),
        c();
    let s = localStorage.getItem("account_address");
    s
        ? ($(".main_account-tabitem").removeClass("main_accounttab-active"),
          $('.main_account-tabitem[data-accounttab="addresses"]').addClass("main_accounttab-active"),
          $(".main_account_tabcontentwrap").removeClass("main_accounttabcontent-active"),
          $('.main_account_tabcontentwrap[data-accounttabcontent="addresses"]').addClass("main_accounttabcontent-active"))
        : ($(".main_account-tabitem:first-child").addClass("main_accounttab-active"), $(".main_account_ordertab-content").addClass("main_accounttabcontent-active")),
        $(".main_account-tabitem:not(.main_account-tabitemlogout)").click(function () {
            var t = $(this).attr("data-accounttab");
            $(".main_account-tabitem").removeClass("main_accounttab-active"),
                $(this).addClass("main_accounttab-active"),
                $(".MuiButtonBase-root#subscription-tab-1").trigger("click"),
                $(".main_account_tabcontentwrap").removeClass("main_accounttabcontent-active"),
                $('.main_account_tabcontentwrap[data-accounttabcontent="' + t + '"]').addClass("main_accounttabcontent-active"),
                t.includes("addresses") || localStorage.removeItem("account_address"),
                $(".main_account-tab-mobilefilter").toggleClass("tab-filter-open"),
                $(window).width() > 767 || $(".main_account-tablist").slideToggle("500");
        }),
        $(".main_account-manageorder").click(function () {
            $(this).parents(".main_account_orderhistory").find(".main_account_ordercontent-body").slideToggle(), $(this).parents(".main_account_orderhistory").toggleClass("is-open");
        }),
        $(".order-item-subscriptionlist").click(function () {
            $(this);
            var t = $(this).parents(".order_item--subscriptioninfo").attr("data-itemvariant"),
                i = $(this).find(".orderitem-subscription-list").attr("data-subscribevalue");
            (data = { id: t, quantity: 1, selling_plan: i }),
                jQuery.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: data,
                    dataType: "json",
                    success: function (t) {
                        var i;
                        fetch("/cart.js")
                            .then((t) => t.json())
                            .then((t) => {
                                i = t.item_count;
                            }),
                            fetch(`${routes.cart_url}?section_id=header`)
                                .then((t) => t.text())
                                .then((t) => {
                                    let i = new DOMParser().parseFromString(t, "text/html"),
                                        o = i.querySelector("#cart-icon-bubble");
                                    document.querySelector("#cart-icon-bubble").innerHTML = o.innerHTML;
                                })
                                .catch((t) => {
                                    console.error(t);
                                }),
                            fetch(`${routes.cart_url}?section_id=cart-drawer`)
                                .then((t) => t.text())
                                .then((t) => {
                                    let o = new DOMParser().parseFromString(t, "text/html"),
                                        l = o.querySelector("cart-drawer");
                                    var a = document.querySelector("cart-drawer");
                                    i > 0 && a.classList.remove("is-empty"),
                                        (a.innerHTML = l.innerHTML),
                                        fetch("/cart.js")
                                            .then((t) => t.json())
                                            .then((t) => {
                                                calculateProgress(t.total_price, cart_shipping_amount);
                                            }),
                                        $(".cart-drawer--collectionproduct").hasClass("slick-initialized") ||
                                            $(".cart-drawer--collectionproduct").slick({
                                                infinite: !1,
                                                slidesToShow: 3,
                                                slidesToScroll: 1,
                                                dots: !1,
                                                arrows: !1,
                                                responsive: [
                                                    { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                                                    { breakpoint: 390, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                                                ],
                                            }),
                                        document.querySelector("#cart-icon-bubble").click();
                                })
                                .catch((t) => {
                                    console.error(t);
                                });
                    },
                });
        }),
        $(".main_account_statusbtn-txt").click(function () {
            $(this).parents(".main_account_statusbutton").toggleClass("status-active"), $(this).parents(".main_account_orderitem-content").find(".main_account_order-stauswrapper").slideToggle();
        }),
        $(".main_account-tab-mobilefilter").click(function () {
            $(this).toggleClass("tab-filter-open"), $(this).siblings(".main_account-tablist").slideToggle("500");
        }),
        767 >= $(window).width() &&
            $(document).on("click", function (t) {
                $(t.target).closest(".main_account-tabwrap").length || ($(".main_account-tab-mobilefilter").removeClass("tab-filter-open"), $(".main_account-tab-mobilefilter").siblings(".main_account-tablist").slideUp("500"));
            }),
        $(".main-quiz-closebtn").click(function () {
            $(".main-quiz-popup-sections").removeClass("openquiz-model"), $("body").removeClass("quizmodel-close");
        }),
        $(".block__quizmaintype--inputvalue").click(function () {
            $(this).is(":checked") &&
                ((i = $(this).val()),
                $(".main-quiz-continuebtn").removeClass("disabled").addClass("quiz-step1"),
                $(".main-quiz-backbtn").removeClass("disabled").addClass("back-to-normal"),
                localStorage.removeItem("quiz_producttag"),
                localStorage.removeItem("quiz_producturl"),
                $(".main-quiz-continuebtn.quiz-step1").click(function (t) {
                    t.preventDefault(),
                        $(".main-quiz-section-content").addClass("main-quiz-section-content-selected"),
                        $('.block__quizmaintype--section[data-quizmaininner-type="' + i + '"]')
                            .find(".block__quizmaintype-stepcontent:first-child")
                            .addClass("activestep"),
                        $('.block__quizmaintype--section[data-quizmaininner-type!="' + i + '"]').css("display", "none"),
                        $('.block__quizmaintype--section[data-quizmaininner-type!="' + i + '"]')
                            .parents(".shopify-section-group-quiz-popup")
                            .css("display", "none"),
                        $('.block__quizmaintype--section[data-quizmaininner-type="' + i + '"]')
                            .parents(".shopify-section-group-quiz-popup")
                            .addClass("active-quiz"),
                        $(".block__quizmaintype--choosevalue").addClass("hidemain-value"),
                        $(this).removeClass("quiz-step1").addClass("quiz-step2"),
                        $(".main-quiz-backbtn").removeClass("back-to-normal"),
                        $(".main-quiz-btnwrapper, .block__quizcontent-heading").css("display", "none");
                }),
                $(".quiz-continuebtn").click(function (t) {
                    t.preventDefault(), $(this).parents(".block__quizmaintype-stepcontent").css("display", "none");
                    var i = $(this),
                        o = !1;
                    $(this)
                        .parents(".block__quizmaintype-stepcontent")
                        .find(".block__quizmain-innerstep-inputvalue:checked")
                        .each(function () {
                            var t = $(this).val(),
                                l = $(this).attr("data-parentstep");
                            if (
                                i
                                    .parents(".block__quizmaintype-stepcontent")
                                    .next(".block__quizmaintype-stepcontent")
                                    .find('.block__quizmaintype-lastoption-content[data-lastoption-parentheading="' + l + '"][data-lastoption-heading="' + t + '"]').length > 0
                            )
                                return (
                                    (o = !0),
                                    $(this).parents(".block__quizmaintype-stepcontent").next(".block__quizmaintype-stepcontent").addClass("activestep"),
                                    $(this).parents(".block__quizmaintype-stepcontent").next(".block__quizmaintype-stepcontent").css("display", "block"),
                                    $(this)
                                        .parents(".block__quizmaintype-stepcontent")
                                        .next(".block__quizmaintype-stepcontent")
                                        .find('.block__quizmaintype-lastoption-content[data-lastoption-parentheading="' + l + '"][data-lastoption-heading="' + t + '"]')
                                        .css("display", "block"),
                                    !1
                                );
                        }),
                        o ||
                            ($(this).parents(".block__quizmaintype-stepcontent").next(".block__quizmaintype-thirdinner-step").removeClass("activestep"),
                            $(this).parents(".block__quizmaintype-stepcontent").siblings(".block__quizmaintype-contactform").css("display", "block"));
                    var l = [],
                        a = "";
                    $(".main-quiz-section-content .block__quizmaintype--section input:checked").each(function () {
                        "" != $(this).attr("data-producttagval") &&
                            ("quizmain-value" == $(this).attr("name")
                                ? (a = "life_stage=" + $(this).attr("data-producttagval").replaceAll(" + ", "+").replaceAll(" ", "+"))
                                : -1 != $(this).attr("data-producttagval").indexOf("Life Stage_")
                                ? (console.log("true"), (a = a + "," + $(this).attr("data-producttagval").replaceAll(" + ", "+").replaceAll(" ", "+")))
                                : l.push($(this).attr("data-producttagval").replaceAll(" + ", "+").replaceAll(" ", "+")));
                    }),
                        console.log(a),
                        localStorage.setItem("quiz_producttag", JSON.stringify(l));
                    var n = localStorage.getItem("quiz_producttag");
                    if (n) {
                        var c = (ArrayData = JSON.parse(n)).join(",").replaceAll(" ", "+");
                        console.log(c), localStorage.setItem("quiz_producturl", a + "&health_focus=" + c);
                    }
                }),
                $(".main-quiz-backbtn").click(function (t) {
                    t.preventDefault();
                    var i = $(this);
                    setTimeout(function () {
                        $(".block__quizmaintype--inputvalue, .block__quizmain-innerstep-inputvalue").prop("checked", !1),
                            $(i).removeClass("back-to-normal").addClass("disabled"),
                            $(".main-quiz-continuebtn, .quiz-continuebtn").addClass("disabled");
                    }, 200);
                }),
                $(".quiz-backbtn").click(function (t) {
                    t.preventDefault(),
                        console.log($(this).parents(".block__quizmaintype-stepcontent").prev(".block__quizmaintype-stepcontent").length),
                        $(this).parents(".block__quizmaintype-stepcontent").prev(".block__quizmaintype-stepcontent").length > 0
                            ? ($(this).parents(".block__quizmaintype-stepcontent").css("display", "none"),
                              $(this).parents(".block__quizmaintype-stepcontent").find(".block__quizmaintype-lastoption-content").css("display", "none"),
                              $(this).parents(".block__quizmaintype-stepcontent").prev(".block__quizmaintype-stepcontent").hasClass("activestep")
                                  ? $(this).parents(".block__quizmaintype-stepcontent").prev(".block__quizmaintype-stepcontent.activestep").css("display", "block")
                                  : $(this).parents(".block__quizmaintype-stepcontent").parents(".block__quizmaintype-innersteps").find(".block__quizmaintype-stepcontent.activestep").last().css("display", "block"))
                            : ($(".main-quiz-section-content").removeClass("main-quiz-section-content-selected"),
                              $(".block__quizmaintype--section, .shopify-section-group-quiz-popup, .block__quizcontent-heading").css("display", "block"),
                              $(".main-quiz-btnwrapper").css("display", "flex"),
                              $(".block__quizmaintype--choosevalue").removeClass("hidemain-value"));
                }),
                $(".main-quiz-continuebtn.quiz-step1").trigger("click"));
        }),
        $(".block__quizmain-innerstep-inputvalue").click(function () {
            $(this).is(":checked")
                ? ((o = $(this).val()),
                  $(this).parents(".block__quizmaintype-stepcontent").nextAll(".block__quizmaintype-stepcontent").removeClass("activestep"),
                  $(this).parents(".block__quizmaintype-stepcontent").find(".quiz-continuebtn").removeClass("disabled").addClass("quiz-next-step"))
                : $(this).parents(".block__quizmaintype-stepcontent").nextAll(".block__quizmaintype-stepcontent").removeClass("activestep");
        }),
        $(".block__page--blogarticle-filterlabel").click(function () {
            $(this).parents(".block__page--blogarticle-filter-level-item").toggleClass("blog-filteropen");
        }),
        $(".block__page--blogarticle-filter-itemval").click(function () {
            $(this).parents(".block__page--blogarticle-filter-itemlabel").toggleClass("selected"),
                $(".block__blogarticle--contentwrap .blog-articles__article").removeClass("active-blog").css("display", "none"),
                setTimeout(function () {
                    $(".block__page--blogarticle-filter-itemlabel.selected").length > 0
                        ? $(".block__page--blogarticle-filter-itemlabel.selected .block__page--blogarticle-filter-itemval").each(function () {
                              var t = $(this).attr("data-filterval"),
                                  i = $(this).attr("data-blogval");
                              $('.block__blogarticle--contentwrap .blog-articles__article[data-blogtitle="' + i + '"][data-articletag*="' + t + '"]')
                                  .addClass("active-blog")
                                  .css("display", "block"),
                                  $(".blog-articles__article.active-blog").length > 0 ? $(".block__blogarticle-nocount").css("display", "none") : $(".block__blogarticle-nocount").css("display", "block");
                          })
                        : ($(".block__blogarticle--contentwrap .blog-articles__article").css("display", "block"), $(".block__blogarticle-nocount").css("display", "none"));
                }, 50);
        }),
        989 >= $(window).width() &&
            $(".block__page--blogarticle-filtertext").click(function () {
                $(this).parents(".block__page--blogarticle-filterwrap").toggleClass("filter-open");
            }),
        $(".blog-articles__article").each(function (t) {
            t >= 9 && $(this).fadeOut("slow").addClass("hide");
        }),
        $(".blog_loadmore_pagination").on("click", function (t) {
            t.preventDefault();
            var i = $(this);
            $(this).addClass("active"),
                setTimeout(function () {
                    i.removeClass("active"), $(".blog-articles__article:hidden").slice(0, 9).slideDown();
                }, 500),
                0 == $(".blog-articles__article:hidden").length && ($(this).fadeOut("slow"), $(this).removeClass("active"));
        }),
        0 == $(".blog-articles__article:hidden").length ? ($(".blog_loadmore_pagination").fadeOut("slow"), $(this).removeClass("active")) : ($(".blog_loadmore_pagination").fadeIn("slow"), $(this).addClass("active")),
        $(window).scroll(function () {
            var t = $(".block__blogarticle--contentwrap").height() - 200;
            $(this).scrollTop() >= t && $(".blog_loadmore_pagination").trigger("click");
        }),
        $(document).on("click", "#noteCheck", function () {
            $(this).is(":checked") ? $(".acknowledgment-lineitem-value").val("Accepted") : $(".acknowledgment-lineitem-value").val("Rejected");
        }),
        $(".mobile-search-modal__close-button").click(function (t) {
            t.preventDefault(), t.stopPropagation(), $(".search-modal .search-modal__content .search-modal__close-button").trigger("click"), $("body").removeClass("boost-pfs-search-suggestion-mobile-open");
        }),
        $(".block__product-note-checkbox").click(function () {
            console.log("sdfs");
            var t = $(".block__product-note-checkbox").length;
            if (1 == t) $(this).prop("checked") ? (console.log($(this).prop("checked")), $(".product-form__submit").attr("disabled", !1)) : $(".product-form__submit").attr("disabled", !0);
            else {
                var i = 0;
                $(".block__product-note-checkbox").each(function () {
                    $(this).prop("checked") && (i += 1);
                }),
                    i == t ? $(".product-form__submit").attr("disabled", !1) : $(".product-form__submit").attr("disabled", !0);
            }
        }),
        $(document).on("click", ".block__quizmain-contactbtn", function () {
            console.log("clicked");
            var t = $(this),
                i = [],
                o = {},
                l = t.parents(".block__quizmain-submitform").find(".block__quizmain-input-fullname").val(),
                a = t.parents(".block__quizmain-submitform").find(".block__quizmain-input-email").val(),
                n = t.parents(".block__quizmain-submitform").find(".block__quizmain-forminput-supplementnote").prop("checked"),
                c = t.parents(".block__quizmain-submitform").find(".block__quizmain-forminput-communication").prop("checked"),
                s = t.parents(".block__quizmain-submitform").find(".block__quizmain-forminput-supplementnote").val(),
                r = t.parents(".block__quizmain-submitform").find(".block__quizmain-forminput-communication").val();
            if ((t.parents(".block__quizmain-submitform").find(".form-success-msg").addClass("hidden"), t.parents(".block__quizmain-submitform").find(".contact__field-email-error").addClass("hidden"), "" == l))
                return (
                    t.parents(".block__quizmain-submitform").find(".contact__field-email-error").removeClass("hidden").find(".form__message-txt").text("Please enter full name"),
                    t.parents(".block__quizmain-submitform").find(".block__quizmain-input-fullname").focus(),
                    !1
                );
            if ("" == a)
                return (
                    t.parents(".block__quizmain-submitform").find(".contact__field-email-error").removeClass("hidden").find(".form__message-txt").text("Please enter Email Address"),
                    t.parents(".block__quizmain-submitform").find(".block__quizmain-input-email").focus(),
                    !1
                );
            if (!/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(a).toLowerCase()))
                return (
                    t.parents(".block__quizmain-submitform").find(".contact__field-email-error").removeClass("hidden").find(".form__message-txt").text("Please enter valid email."),
                    t.parents(".block__quizmain-submitform").find(".block__quizmain-input-email").focus(),
                    !1
                );
            if (!1 == n)
                return (
                    t.parents(".block__quizmain-submitform").find(".contact__field-email-error").removeClass("hidden").find(".form__message-txt").text("Please fill up the checkbox"),
                    t.parents(".block__quizmain-submitform").find(".block__quizmain-input-email").focus(),
                    !1
                );
            if (!1 == c)
                return (
                    t.parents(".block__quizmain-submitform").find(".contact__field-email-error").removeClass("hidden").find(".form__message-txt").text("Please fill up the checkbox"),
                    t.parents(".block__quizmain-submitform").find(".block__quizmain-input-email").focus(),
                    !1
                );
            $(".active-quiz .block__quizmain-formfield").each(function () {
                console.log($(this).val()), i.push($(this).val());
            }),
                console.log(i),
                (o.g = "Xr9dtY"),
                (o.email = a),
                (o.fullname = l),
                (o.Ask_your_doctor = s),
                (o.Newsletter_subscribe = r),
                (o.$consent = !0),
                (o.$fields = "Full name,Ask_your_doctor,Newsletter_subscribe"),
                (o.$source = "Quiz Shopify Page");
            var d = { async: !0, crossDomain: !0, url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe", method: "POST", headers: { "content-type": "application/x-www-form-urlencoded", "cache-control": "no-cache" }, data: o };
            $.ajax(d).done(function (i) {
                console.log(d),
                    t.parents(".block__quizmain-submitform").find(".form-success-msg").removeClass("hidden"),
                    t.parents(".block__quizmain-submitform").find(".contact__field-email-error").addClass("hidden"),
                    _learnq.push(["identify", { $email: a }]),
                    setTimeout(function () {
                        _learnq.push(["track", "Quiz Event"]);
                        var t = localStorage.getItem("quiz_producttag"),
                            i = localStorage.getItem("quiz_producturl");
                        if (i) {
                            var o = (ArrayData = JSON.parse(t)).join("+").replaceAll(" ", "+");
                            console.log(o), (window.location = "/search?" + i);
                        }
                    }, 1500);
            });
        });
}),
    window.addEventListener("load", (t) => {
        0 == $(".boost-pfs-filter-options-wrapper .boost-pfs-filter-option").find(".boost-pfs-filter-heading").length &&
            ($(".boost-pfs-filter-heading").remove(),
            setTimeout(function () {
                $(".boost-pfs-filter-options-wrapper .boost-pfs-filter-option:first-child").prepend('<div class="boost-pfs-filter-heading">Filter by</div>');
            }, 200))
    }),
    $(window).resize(function () {
        $(window).width() >= 576 ? product_multitab() : 575 >= $(window).width() && ($(".block__product--innertab").length > 3 ? product_multitab_mob() : product_multitab()),
            767 >= $(window).width()
                ? (testimonial_typeslick(),
                  $(".block__productlist--itemlist").hasClass("slick-initialized") &&
                      setTimeout(function () {
                          $(".block__productlist--itemlist").slick("unslick");
                      }, 100),
                  $(".block__dailyroutine-mobilebtn").click(function (t) {
                      t.preventDefault(), Dailyroutine_filter_result();
                  }))
                : ($(".block__testimonial--reviewtype-content").hasClass("slick-initialized") &&
                      setTimeout(function () {
                          $(".block__testimonial--reviewtype-content").slick("unslick");
                      }, 100),
                  collection_productlist(),
                  $('.block__dailyroutine--filter-item input[type="checkbox"]').change(function (t) {
                      t.preventDefault(), Dailyroutine_filter_result();
                  })),
            576 > $(window).width()
                ? $(".block__product--innertab-desc-content")
                      .on("afterChange", function (t, i, o, l) {
                          if (void 0 != o) {
                              $(".block__product--innertab").removeClass("block__product--innertab-active");
                              var a = $('.block__product--tabcontent--desc[data-slick-index="' + o + '"]').attr("data-producttabcontent");
                              $('.block__product--innertab[data-producttab="' + a + '"]').addClass("block__product--innertab-active");
                          }
                      })
                      .trigger("afterChange")
                : $(".block__product--innertab-desc-content")
                      .on("afterChange", function (t, i, o, l) {
                          void 0 != o && ($(".block__product--innertab").removeClass("block__product--innertab-active"), $('.block__product--innertab[data-slick-index="' + o + '"]').addClass("block__product--innertab-active"));
                      })
                      .trigger("afterChange"),
            $(window).width() > 767
                ? $(".related-product-content").hasClass("slick-initialized") ||
                  $(".related-product-content")
                      .slick({
                          infinite: !1,
                          slidesToShow: 4,
                          slidesToScroll: 1,
                          dots: !0,
                          prevArrow:
                              '<button class="block__relatedproduct-arrow slick-prev slick-arrow prev-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.8284 10.9999L13.1924 5.63589L11.7782 4.22168L4 11.9999L11.7782 19.778L13.1924 18.3638L7.8284 12.9999H20V10.9999H7.8284Z" fill="#22202E"/></svg></button>',
                          nextArrow:
                              '<button class="block__relatedproduct-arrow slick-next slick-arrow next-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" fill="#22202E"/></svg></button>',
                          responsive: [
                              { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                              { breakpoint: 768, settings: { slidesToShow: 2, centerMode: !0, centerPadding: "20px", speed: 300, infinite: !0, slidesToScroll: 1 } },
                          ],
                      })
                      .on("setPosition", function (t, i) {
                          i.$slides.css("height", i.$slideTrack.height() + "px");
                      })
                : $(".related-product-content").hasClass("slick-initialized") &&
                  setTimeout(function () {
                      $(".related-product-content").slick("unslick");
                  }, 100),
            989 >= $(window).width() &&
                $(".block__page--blogarticle-filtertext").click(function () {
                    $(this).parents(".block__page--blogarticle-filterwrap").toggleClass("filter-open");
                });
    });